<template>
  <div>
    <b-card class="border-0 shadow-sm mb-3" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
      <template #header>
        <div class="d-flex align-items-center">
          <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
            <i class="fa fa-truck"></i>
          </div>
          <div>
            <h6 class="mb-0 font-weight-bold">Informações Básicas</h6>
            <small class="text-muted">Identificação e dados principais do veículo</small>
          </div>
        </div>
      </template>

      <b-row>
        <b-col md="3">
          <label class="modal-label-premium">Tipo de Veículo *</label>
          <b-form-select 
            v-model="formularioLocal.OP_TIPO" 
            :disabled="readonly" 
            :state="formularioLocal.OP_TIPO ? null : false"
            class="rounded-pill shadow-xs"
          >
            <b-form-select-option value="1">Carro</b-form-select-option>
            <b-form-select-option value="2">Moto</b-form-select-option>
            <b-form-select-option value="3">Cavalinho</b-form-select-option>
            <b-form-select-option value="4">Carreta</b-form-select-option>
            <b-form-select-option value="5">Caçamba</b-form-select-option>
            <b-form-select-option value="6">Trator</b-form-select-option>
            <b-form-select-option value="7">Balsa</b-form-select-option>
            <b-form-select-option value="8">Barco</b-form-select-option>
            <b-form-select-option value="9">Caminhão</b-form-select-option>
          </b-form-select>
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Nome/Descrição do Veículo *</label>
          <b-form-input 
            v-model="formularioLocal.NOME" 
            :disabled="readonly" 
            :state="formularioLocal.NOME && formularioLocal.NOME.trim() ? null : false"
            maxlength="100" 
            class="rounded-pill shadow-xs"
          ></b-form-input>
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Situação *</label>
          <b-form-select v-model="formularioLocal.OP_SITUACAO" :disabled="readonly" class="rounded-pill shadow-xs">
            <b-form-select-option value="1">Ativo</b-form-select-option>
            <b-form-select-option value="0">Inativo</b-form-select-option>
          </b-form-select>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="3">
          <label class="modal-label-premium">Placa</label>
          <b-form-input v-model="formularioLocal.PLACA" :disabled="readonly" maxlength="9" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">RENAVAM</label>
          <b-form-input v-model="formularioLocal.RENAVAM" :disabled="readonly" maxlength="20" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Chassi</label>
          <b-form-input v-model="formularioLocal.CHASSI" :disabled="readonly" maxlength="20" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>
      </b-row>
    </b-card>

    <!-- Dados do Veículo -->
    <b-card class="border-0 shadow-sm mb-3" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
      <template #header>
        <div class="d-flex align-items-center">
          <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
            <i class="fa fa-gear"></i>
          </div>
          <div>
            <h6 class="mb-0 font-weight-bold">Dados do Veículo</h6>
            <small class="text-muted">Características técnicas e documentação</small>
          </div>
        </div>
      </template>

      <b-row>
        <b-col md="4">
          <label class="modal-label-premium">Marca</label>
          <b-form-input v-model="formularioLocal.MARCA" :disabled="readonly" maxlength="100" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Modelo</label>
          <b-form-input v-model="formularioLocal.MODELO" :disabled="readonly" maxlength="50" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>

        <b-col md="2">
          <label class="modal-label-premium">Ano</label>
          <b-form-input v-model.number="formularioLocal.ANO" :disabled="readonly" type="number" min="1900" max="2100" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>

        <b-col md="2">
          <label class="modal-label-premium">Cor</label>
          <b-form-input v-model="formularioLocal.COR" :disabled="readonly" maxlength="20" class="rounded-pill shadow-xs"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="3">
          <label class="modal-label-premium">Combustível</label>
          <b-form-select v-model="formularioLocal.OP_COMBUSTIVEL" :disabled="readonly" class="rounded-pill shadow-xs">
            <b-form-select-option value="1">Gasolina</b-form-select-option>
            <b-form-select-option value="2">Álcool</b-form-select-option>
            <b-form-select-option value="3">Diesel</b-form-select-option>
            <b-form-select-option value="4">GNV</b-form-select-option>
            <b-form-select-option value="5">Flex</b-form-select-option>
            <b-form-select-option value="6">Outros</b-form-select-option>
          </b-form-select>
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">IPVA</label>
          <b-form-select v-model="formularioLocal.OP_IPVA" :disabled="readonly" class="rounded-pill shadow-xs">
            <b-form-select-option value="1">Isento</b-form-select-option>
            <b-form-select-option value="0">Não Isento</b-form-select-option>
          </b-form-select>
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Licença</label>
          <b-form-select v-model="formularioLocal.OP_LICENCA" :disabled="readonly" class="rounded-pill shadow-xs">
            <b-form-select-option value="0">Irregular</b-form-select-option>
            <b-form-select-option value="1">Regular</b-form-select-option>
          </b-form-select>
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Odômetro na Compra</label>
          <b-form-input v-model.number="formularioLocal.ODOMETRO_COMPRA" :disabled="readonly" type="number" min="0" class="rounded-pill shadow-xs text-right"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="3">
          <label class="modal-label-premium">Data da Compra</label>
          <cec-input-data
            v-model="formularioLocal.DATA_COMPRA"
            :disabled="readonly"
            input-class="rounded-pill shadow-xs"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Capacidade (kg)</label>
          <vue-autonumeric
            v-model="formularioLocal.CAPACIDADE"
            :disabled="readonly"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            class="form-control rounded-pill shadow-xs text-right"
          />
        </b-col>

        <b-col md="3">
          <label class="modal-label-premium">Tara (kg)</label>
          <vue-autonumeric
            v-model="formularioLocal.TARA"
            :disabled="readonly"
            :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }"
            class="form-control rounded-pill shadow-xs text-right"
          />
        </b-col>
      </b-row>
    </b-card>

    <!-- Localização e Proprietário -->
    <b-card class="border-0 shadow-sm mb-3" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
      <template #header>
        <div class="d-flex align-items-center">
          <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
            <i class="fa fa-map-marker"></i>
          </div>
          <div>
            <h6 class="mb-0 font-weight-bold">Localização e Responsáveis</h6>
            <small class="text-muted">Endereço, proprietário, motorista e transportadora</small>
          </div>
        </div>
      </template>

      <b-row>
        <b-col md="2">
          <label class="modal-label-premium">UF</label>
          <b-form-select v-model="formularioLocal.UF_ID" :options="estados" value-field="ID" text-field="ID" :disabled="readonly" class="rounded-pill shadow-xs" @change="onUfChange"></b-form-select>
        </b-col>

        <b-col md="4">
          <label class="modal-label-premium">Município</label>
          <div class="d-flex align-items-center">
            <b-form-select v-model="formularioLocal.MUNICIPIO_ID" :options="municipios" :disabled="municipiosBusy || !formularioLocal.UF_ID || readonly" value-field="ID" text-field="NOME" class="rounded-pill shadow-xs flex-grow-1"></b-form-select>
            <b-spinner v-if="municipiosBusy" small class="ml-2 text-primary"></b-spinner>
          </div>
        </b-col>

        <b-col md="6">
          <cliente-pesquisa 
            @retornaId="formularioLocal.PROPRIETARIO_ID = $event" 
            :idInicial="formularioLocal.PROPRIETARIO_ID" 
            label="Proprietário" 
            place="Informe o Proprietário"
            :arredondado="true"
            :desabilitarInput="readonly"
          ></cliente-pesquisa>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col md="6">
          <label class="modal-label-premium">Motorista Padrão</label>
          <funcionario-dropdown 
            v-model="formularioLocal.MOTORISTA_ID"
            :disabled="readonly"
            input-class="rounded-pill shadow-xs"
          ></funcionario-dropdown>
        </b-col>

        <b-col md="6">
          <label class="modal-label-premium">Transportadora</label>
          <transportadora-drop-down 
            v-model="formularioLocal.TRANSPORTADORA_ID"
            :disabled="readonly"
            input-class="rounded-pill shadow-xs"
          ></transportadora-drop-down>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import VueAutonumeric from 'vue-autonumeric'
import ClientePesquisa from '../../../pesquisa/ClientePesquisa'
import FuncionarioDropdown from '../../../componentes/dropdown/FuncionarioDropdown.vue'
import TransportadoraDropDown from '../../../componentes/dropdown/TransportadoraDropDown.vue'
import CecInputData from '../../../../components/Cec/CecInputData.vue'

export default {
  name: 'FormularioVeiculo',
  components: {
    VueAutonumeric,
    ClientePesquisa,
    FuncionarioDropdown,
    TransportadoraDropDown,
    CecInputData
  },
  props: {
    formulario: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formularioLocal: { ...this.formulario },
      estados: [],
      municipios: [],
      municipiosBusy: false
    }
  },
  computed: {
    isDark () {
      return this.$store.getters.getTheme === 'dark'
    }
  },
  watch: {
    formularioLocal: {
      handler (newVal) {
        this.$emit('update:formulario', newVal)
      },
      deep: true
    },
    'formularioLocal.UF_ID': function (newVal) {
      if (newVal) {
        this.getMunicipios()
      } else {
        this.municipios = []
        this.formularioLocal.MUNICIPIO_ID = null
      }
    }
  },
  async mounted () {
    await this.getEstados()
    if (this.formularioLocal.UF_ID) {
      await this.getMunicipios()
    }
  },
  methods: {
    async getEstados () {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
      } catch (error) {
        console.error('Erro ao buscar estados:', error)
        this.estados = []
      }
    },
    async getMunicipios () {
      if (!this.formularioLocal.UF_ID) return
      
      this.municipiosBusy = true
      try {
        const result = await this.$http.get(`/api/protected/municipios/${this.formularioLocal.UF_ID}`)
        this.municipios = result.data
      } catch (error) {
        console.error('Erro ao buscar municípios:', error)
        this.municipios = []
      } finally {
        this.municipiosBusy = false
      }
    },
    onUfChange () {
      this.formularioLocal.MUNICIPIO_ID = null
    }
  }
}
</script>

<style scoped>
.modal-label-premium {
  font-size: 0.875rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.25rem;
  display: block;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.shadow-xs {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/veiculo/components/FormularioVeiculo.vue